import Service from "./Service"

class TaskTypeService extends Service {

    findById = (id) => this.get(`/task-types/${id}`)

    search = () => this.get("/task-types")

    getSelectors = () => this.get("/task-types/selectors")

    createTaskType = (requestBody) => this.post("/task-types", requestBody)

    updateTaskType = (taskTypeId, requestBody) => this.patch(`/task-types/${taskTypeId}`, requestBody)

    deleteTaskType = (taskTypeId) => this.del(`/task-types/${taskTypeId}`)
}

const taskTypeService = new TaskTypeService()
export default taskTypeService